module.exports = __webpack_public_path__ + "09_face.bca01f82.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer1/09_face.png
// module id = KWde
// module chunks = 0